export default {
  path: 'welfare',
  name: 'welfare',
  component: () => import('@/views/welfare/index.vue'),
  meta: {
    locale: '福利',
    requiresAuth: true,
    icon: 'icon-gift',
  },
  children: [
    {
      path: 'welfare-grant',
      name: 'welfareGrant',
      component: () => import('@/views/welfare/grant/index.vue'),
      meta: {
        locale: '福利中心',
        requiresAuth: true,
        roles: [
          'super',
          'admin',
          'service',
          'special_service',
          'treasurer',
          'user',
        ],
      },
    },
  ],
};
